import Link from "components/Link";
import useLocalizedUrls from "hooks/useLocalizedUrls";
import { Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import CheckboxField from "./index";

interface Props {
  id: string;
  name: string;
  className?: string;
  required?: boolean;
}

const PrivacyPolicyCheckboxField: React.FC<Props> = ({
  id,
  name,
  className,
  required,
}) => {
  const { t } = useTranslation();
  const { privacyPolicyUrl } = useLocalizedUrls();

  return (
    <CheckboxField
      id={id}
      name={name}
      className={className}
      label={
        <Text variant="body8" color="quaternary">
          {t("13979") /* Li e aceito a */}
          &nbsp;
          <Link
            target="_blank"
            href={privacyPolicyUrl}
            underline="always"
            rel="noopener"
          >
            {t("6005") /* Política de Privacidade */}
          </Link>
          .{" "}
          {required && (
            <Text className="inline" variant="body8" color="danger">
              *
            </Text>
          )}
        </Text>
      }
    />
  );
};

export default PrivacyPolicyCheckboxField;
